import { clarity } from 'react-microsoft-clarity'
import { runWhenIdleAfterLoad } from './runWhenIdle'

const CLARITY_PROJECT_ID = 'l90db3dijc'

/**
 * Session recording, started once the app is idle so it doesn't compete with the cold start.
 * The queue stub Clarity's own loader installs goes in first, so `identify`/`setTag` calls made
 * before the script arrives are replayed by it rather than lost.
 */
export const startClarityWhenIdle = (): void => {
  const queue: unknown[] = []
  const stub = Object.assign((...args: unknown[]) => queue.push(args), { q: queue })
  const page = window as unknown as { clarity?: typeof stub }
  page.clarity ??= stub
  runWhenIdleAfterLoad(() => clarity.init(CLARITY_PROJECT_ID))
}
